import { render, staticRenderFns } from "./MonthCalendar.vue?vue&type=template&id=dd8b8c8e&"
import script from "./MonthCalendar.vue?vue&type=script&lang=js&"
export * from "./MonthCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports